export default {"src":"/_next/static/media/cart-shopping-classic-solid.e8c570ce.svg","height":24,"width":24};